import React from 'react';
import './privacy.css';

function Privacy() {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Chính sách bảo mật</h1>
        <p className="privacy-updated">Cập nhật lần cuối: 01/10/2025</p>
      </div>

      <div className="privacy-content">
        <section className="privacy-section">
          <h2>1. Thông tin chúng tôi thu thập</h2>
          <h3>1.1. Thông tin cá nhân</h3>
          <ul>
            <li>Địa chỉ email khi bạn đăng ký tài khoản</li>
            <li>Tên hiển thị và thông tin hồ sơ</li>
            <li>Thông tin đăng nhập và mật khẩu đã được mã hóa</li>
          </ul>

          <h3>1.2. Thông tin sử dụng</h3>
          <ul>
            <li>Dữ liệu về cách bạn tương tác với dịch vụ</li>
            <li>Thông tin thiết bị và trình duyệt</li>
            <li>Địa chỉ IP và dữ liệu vị trí</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>2. Cách chúng tôi sử dụng thông tin</h2>
          <ul>
            <li>Cung cấp và cải thiện dịch vụ GiveLive</li>
            <li>Xác thực người dùng và bảo mật tài khoản</li>
            <li>Gửi thông báo về dịch vụ và cập nhật</li>
            <li>Phân tích và tối ưu hóa hiệu suất hệ thống</li>
            <li>Tuân thủ nghĩa vụ pháp lý</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. Bảo mật thông tin</h2>
          <p>
            Chúng tôi áp dụng các biện pháp bảo mật nghiêm ngặt để bảo vệ thông tin của bạn:
          </p>
          <ul>
            <li>Mã hóa dữ liệu nhạy cảm</li>
            <li>Kiểm soát truy cập và xác thực hai lớp</li>
            <li>Giám sát và cập nhật hệ thống bảo mật thường xuyên</li>
            <li>Đào tạo nhân viên về quy trình bảo mật</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Chia sẻ thông tin</h2>
          <p>Chúng tôi không chia sẻ thông tin cá nhân của bạn với bên thứ ba, ngoại trừ:</p>
          <ul>
            <li>Khi có sự đồng ý rõ ràng từ bạn</li>
            <li>Để tuân thủ yêu cầu pháp lý</li>
            <li>Để bảo vệ quyền và tài sản của chúng tôi</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. Cookie và công nghệ theo dõi</h2>
          <p>
            Chúng tôi sử dụng cookie và các công nghệ tương tự để:
          </p>
          <ul>
            <li>Duy trì phiên đăng nhập của bạn</li>
            <li>Ghi nhớ tùy chọn và cài đặt</li>
            <li>Phân tích lưu lượng truy cập</li>
            <li>Cải thiện trải nghiệm người dùng</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>6. Quyền của người dùng</h2>
          <p>Bạn có quyền:</p>
          <ul>
            <li>Truy cập và xem thông tin cá nhân của mình</li>
            <li>Yêu cầu chỉnh sửa thông tin không chính xác</li>
            <li>Yêu cầu xóa tài khoản và dữ liệu</li>
            <li>Phản đối việc xử lý thông tin của bạn</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Privacy; 